import { request } from '@/shared/api/request'

export const getCalc = ({params, payload}) => {
	return request({ url: `contract/universalMethods/${payload.type}`, method: 'get', params })
}